import { ChangeDetectorRef, Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { take } from 'rxjs';
import { BuyerRepresentationDTO } from '../../DTO/buyerRepresentationDTO';
import { ApplicationUserAbstract } from '../../models/applicationUserAbstract';
import { BuyerRepresentation } from '../../models/buyerRepresentation';
import { UserManagementApiService } from '../../services/UserManagementApiService';

@Component({ standalone: false,
  selector: 'representations-dialog',
  templateUrl: 'representations-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class RepresentationsDialogComponent {
  public title: string= "Representations";
  public confirmButtonText = "OK";
  public applicationUserAbstract?:ApplicationUserAbstract;
  public buyerRepresentations?:BuyerRepresentation[];
  public busy:boolean=false;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<RepresentationsDialogComponent>, private umApiService:UserManagementApiService, private cdRef:ChangeDetectorRef) {
    if(data){
      this.applicationUserAbstract=data.user;
    }
  }

  ngAfterViewInit(){
    if(this.applicationUserAbstract?.brokerId){
      this.busy=true;
      this.cdRef.detectChanges();
      this.umApiService.getUserBrokerBuyerRepresentations(this.applicationUserAbstract?.brokerId).pipe(take(1)).subscribe(dtoArray=>{
        this.buyerRepresentations = dtoArray.map((dto:BuyerRepresentationDTO)=>BuyerRepresentation.mapFromDTO(dto));
        this.busy=false;
      });
    }
  }

  public onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}